/* SHIMP: Shuffle products on collection pages
   Disable: set window.SHIMP_NO_SHUFFLE = true before this script loads
   Or remove the script tag from theme.liquid */
(function(){
  if(window.SHIMP_NO_SHUFFLE) return;
  if(!window.location.pathname.includes("/collections/nyheter")) return;
  function shuffle(){
    var grid = document.querySelector("grid-list.products-list");
    if(!grid) return;
    var items = Array.from(grid.children);
    for(var i = items.length - 1; i > 0; i--){
      var j = Math.floor(Math.random() * (i + 1));
      grid.appendChild(items[j]);
    }
  }
  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", shuffle);
  } else {
    shuffle();
  }
})();
